import React, { useEffect, useState } from 'react';
import { Alert, Button, Col, Container, Form, Row, Spinner } from 'react-bootstrap';
import { businessName, apiUrl } from '../../utils/consts';
import background from '../../img/background.jpg';
import LogoComponent from '../Logo/LogoComponent';
import { setInStorage } from '../../utils/storage';
import { userLogin } from '../../redux/modules/auth';
import { connect } from 'react-redux';
import './styles/CreateAccount.scss';

function mapDispatchToProps(dispatch) {
  return {
    userLogin: payload => dispatch(userLogin(payload))
  };
}

function ConnectedCreateAccountComponent(props) {

  const [tab, setTab] = useState(0);
  const [document, setDocument] = useState('');
  const [birthDate, setBirthDate] = useState('');
  const [phone, setPhone] = useState('');
  const [name, setName] = useState('');
  const [lastName, setLastName] = useState('');
  const [city, setCity] = useState('');
  const [email, setEmail] = useState('');
  const [emailConf, setEmailConf] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConf, setPasswordConf] = useState('');
  const [validated, setValidated] = useState(false);
  const [userId, setUserId] = useState('');
  const [loading, setLoading] = useState(false);
  const [loadingSignin, setLoadingSignin] = useState(false);
  const [error, setError] = useState('');
  const [accountCreated, setAccountCreated] = useState(false);

  useEffect(() => {
    if (loading) setError('');
  }, [loading]);

  const handleSubmit = async event => {
    event.preventDefault();
    event.stopPropagation();

    setValidated(true);

    const form = event.currentTarget;

    if (form.checkValidity()) {

      if (tab === 0) {

        setLoading(true);

        const verifyFetch = await fetch(`${apiUrl}/users/verify`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            document,
            birthDate
          })
        });

        const verifyUser = await verifyFetch.json();

        if (verifyUser.success && verifyUser.userId) {
          setUserId(verifyUser.userId);
          setValidated(false);
          setTab(1);
        } else {
          setError(
            'Error en datos de usuario. Por favor contactar al administrador.'
          );
        }

        setLoading(false);

      } else if (tab === 1) {

        if (email !== emailConf) {
          setError('El correo electrónico no coincide.');
        } else if (password !== passwordConf) {
          setError('Las contraseñas no coinciden.');
        } else {

          setLoading(true);

          const createProm = await fetch(`${apiUrl}/users/create`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              document,
              birthDate,
              userId,
              email,
              firstName: name,
              lastName,
              password,
              businessName,
              phone,
              city
            })
          });

          const createResp = await createProm.json();

          if (!createResp.success) setError(createResp.message);
          else setAccountCreated(true);

          setLoading(false);
        }

      }
    }
  };

  const signin = async () => {
    setLoadingSignin(true);

    const loginProm = await fetch(`${apiUrl}/users/signin`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email,
        password,
        businessName
      })
    });

    const loginResp = await loginProm.json();

    if (loginResp.success) {
      props.userLogin({ user: loginResp.user, userId: loginResp.userId, token: loginResp.token });
      setInStorage('nibi_business_app', { token: loginResp.token });
      props.history.push('/');
    } else {
      setLoadingSignin(false);
      alert('Error. Por favor inténtalo nuevamente.');
    }
  };

  return (
    <div className="create-account-component">
      <div className="login-container" style={{ backgroundImage: `url(${background})` }}>
        <LogoComponent />
        <Container>
          <Row>
            <Col xs={12}>
              <div className="form-container">
                {
                  accountCreated ?
                  <>
                    <h1 className="app-title" style={{ fontSize: '1.75rem', textAlign: 'center', marginBottom: '30px' }}>
                      Cuenta creada exitosamente.
                    </h1>
                    <Button className="app-button" onClick={signin} disabled={loadingSignin}>
                      {
                        loadingSignin ? <Spinner animation="border" variant="warning" size="sm" /> : 'Continuar'
                      }
                    </Button>
                  </> :
                  <Form noValidate validated={validated} onSubmit={handleSubmit}>
                    {
                      tab === 0 ?
                      <Form.Row>
                        <Col xs={12}>
                          <i className="fas fa-arrow-alt-circle-left back-icon" onClick={() => props.history.push('/')} />
                        </Col>
                        <Form.Group as={Col} xs={6}>
                          <Form.Label className="app-label">Número de cédula</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Cédula"
                            value={document}
                            onChange={event => setDocument(event.target.value)}
                            required
                          />
                        </Form.Group>
                        <Form.Group as={Col} xs={6}>
                          <Form.Label className="app-label">Fecha de nacimiento</Form.Label>
                          <Form.Control
                            type="date"
                            value={birthDate}
                            onChange={event => setBirthDate(event.target.value)}
                            required
                          />
                        </Form.Group>
                      </Form.Row> :
                      <Form.Row>
                        <Col xs={12}>
                          <i className="fas fa-arrow-alt-circle-left back-icon" onClick={() => setTab(0)} />
                        </Col>
                        <Form.Group as={Col} xs={6}>
                          <Form.Label className="app-label">Nombre</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Nombre"
                            value={name}
                            onChange={event => setName(event.target.value)}
                            required
                          />
                        </Form.Group>
                        <Form.Group as={Col} xs={6}>
                          <Form.Label className="app-label">Apellido</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Apellido"
                            value={lastName}
                            onChange={event => setLastName(event.target.value)}
                            required
                          />
                        </Form.Group>
                        <Form.Group as={Col} xs={6}>
                          <Form.Label className="app-label">Teléfono</Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Teléfono"
                            value={phone}
                            onChange={event => setPhone(event.target.value)}
                            required
                          />
                        </Form.Group>
                        <Form.Group as={Col} xs={6}>
                          <Form.Label className="app-label">Ciudad</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Ciudad de residencia"
                            value={city}
                            onChange={event => setCity(event.target.value)}
                            required
                          />
                        </Form.Group>
                        <Form.Group as={Col} xs={6}>
                          <Form.Label className="app-label">Correo electrónico</Form.Label>
                          <Form.Control
                            type="email"
                            placeholder="Correo"
                            value={email}
                            onChange={event => setEmail(event.target.value)}
                            required
                          />
                        </Form.Group>
                        <Form.Group as={Col} xs={6}>
                          <Form.Label className="app-label">Confirmar correo electrónico</Form.Label>
                          <Form.Control
                            type="email"
                            placeholder="Correo"
                            value={emailConf}
                            onChange={event => setEmailConf(event.target.value)}
                            required
                          />
                        </Form.Group>
                        <Form.Group as={Col} xs={6}>
                          <Form.Label className="app-label">Contraseña</Form.Label>
                          <Form.Control
                            type="password"
                            placeholder="Contraseña"
                            value={password}
                            onChange={event => setPassword(event.target.value)}
                            required
                          />
                        </Form.Group>
                        <Form.Group as={Col} xs={6}>
                          <Form.Label className="app-label">Confirmar Contraseña</Form.Label>
                          <Form.Control
                            type="password"
                            placeholder="Contraseña"
                            value={passwordConf}
                            onChange={event => setPasswordConf(event.target.value)}
                            required
                          />
                        </Form.Group>
                        <Col xs={12}>
                          <div className="custom-control custom-checkbox">
                            <input type="checkbox" className="custom-control-input" id="tycCb" required />
                            <label className="custom-control-label app-label" htmlFor="tycCb" style={{ fontSize: '1rem' }}>
                              Acepto los <a href="https://docs.google.com/document/d/e/2PACX-1vRxNMIb79GUH5crhif3_0tf86LRF8ya3EvCHk9KaKjrmaIQkTmerJK77m4YPTOGnQ/pub" target="_blank" rel="noopener noreferrer">términos y condiciones</a> y la <a href="https://docs.google.com/document/d/e/2PACX-1vQAHdcqEsBdWYxpAXCWWTDBvl2AQxXAZE_qdxIaO7cfRE0Y7DR8VcvhBIERTHKvHQ/pub" target="_blank" rel="noopener noreferrer">política de tratamiento de datos</a>.
                            </label>
                          </div>
                          <br />
                        </Col>
                      </Form.Row>
                    }
                    <Button type="submit" disabled={loading} className="app-button">
                      {
                        loading ? <Spinner animation="border" variant="warning" size="sm" /> : 'Confirmar'
                      }
                    </Button>
                    {
                      error &&
                      <>
                        <br />
                        <Alert variant="danger">
                          { error }
                        </Alert>
                      </>
                    }
                  </Form>
                }
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

const CreateAccountComponent = connect(null, mapDispatchToProps)(ConnectedCreateAccountComponent);

export default CreateAccountComponent;
